import React, { useRef, useState } from 'react'
import "./ProductModal.css"
import { convert64 } from '../../utils/images_manager'
import axios from 'axios'
import { api } from '../../settings/env'
import Swal from 'sweetalert2'

export default function ProductModal({ product, close, getProducts, type }) {

    const [moodEdit, setMoodEdit] = useState(false)
    const [title, setTitle] = useState(false)
    const [description, setDescription] = useState(false)
    const [image, setImage] = useState(false)
    const [price, setPrice] = useState(false)
    const [loader, setLoader] = useState(false)
    const imgProfileRef = useRef()
    const uri = type == "servicio" ? "services" : "products"

    const handleImage = async (e) => {
        try {
            const management_image = await convert64(e);

            console.log("MANAGEMENT IMAGE", management_image);

            if (management_image && management_image !== null) {
                console.log("Entró en true");
                setImage(management_image); // Aquí puedes guardar la imagen convertida
            } else {
                console.log("Reseteando el input debido a un error");
                imgProfileRef.current.value = ""; // Reinicia el campo de entrada
                alert("Hubo un problema con la imagen. Por favor, intenta con otro archivo.");
            }
        } catch (error) {
            console.error("Error al manejar la imagen:", error);
            imgProfileRef.current.value = ""; // Reinicia el campo si ocurre un error
            alert("Ocurrió un error al procesar la imagen. Por favor, inténtalo nuevamente.");
        }
    };

    const save = () => {
        setLoader(true);

        const data = {
            name: title,
            description: description,
            price: parseFloat(price),
            image: image,
            professionalId: localStorage.getItem("vitaly_userid")
        }

        axios.put(`${api}/${uri}/edit/${product.id}`, data)
            .then(resp => {
                console.log(resp.data)
                setLoader(false);
                getProducts()
                close()
            })
            .catch(err => console.log(err))
    }

    const deleteProduct = () => {
        Swal.fire({
            title: "¿Estás seguro?",
            text: "Este cambio no es reversible",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            cancelButtonText: "Cancelar",
            confirmButtonText: "Sí, eliminar!"
        }).then((result) => {
            if (result.isConfirmed) {
                axios.delete(`${api}/${uri}/delete/${product.id}`)
                    .then(resp => {
                        console.log(resp)

                        Swal.fire({
                            title: "Eliminado!",
                            text: "Este producto ha sido eliminado.",
                            icon: "success"
                        });

                        close();
                        getProducts();
                    })
                    .catch(err => console.log(err))


            }
        });
    }

    return (
        <div className='modal-background'>
            <div className="modal-content-product">
                <div className='option-close'>
                    <span onClick={close}>X</span>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <img
                            width={"100%"}
                            src={moodEdit && image ? image : product.image}
                            alt=""
                        />
                    </div>
                    <div className="col-md-6">
                        <h4>
                            {moodEdit ? "Modo edición" : product.name}
                        </h4>

                        {
                            !moodEdit ?
                                <>
                                    <p>{product.description}</p>
                                    <p>Precio: 10</p>

                                    <button className='btn btn-info' onClick={(e) => setMoodEdit(true)}>
                                        Editar
                                    </button>

                                    <button className='btn btn-danger mx-4' onClick={deleteProduct}>
                                        Eliminar
                                    </button>
                                </>
                                :
                                <>
                                    <input
                                        type="text"
                                        className='form-control my-4'
                                        placeholder='Título'
                                        onKeyUp={(e) => setTitle(e.target.value)}
                                    />

                                    <input
                                        type="text"
                                        className='form-control my-4'
                                        placeholder='Descripcion'
                                        onKeyUp={(e) => setDescription(e.target.value)}
                                    />

                                    <input
                                        type="number"
                                        className='form-control my-4'
                                        placeholder='Precio'
                                        onKeyUp={(e) => setPrice(e.target.value)}
                                    />

                                    <input
                                        type="file"
                                        ref={imgProfileRef}
                                        className='form-control my-4'
                                        placeholder='Título'
                                        onChange={handleImage}
                                    />



                                    <button className='btn btn-info' onClick={save}>
                                        {loader ? "Guardando..." : "Guardar"}
                                    </button>

                                    <button className='btn btn-danger mx-4' onClick={() => setMoodEdit(false)}>
                                        Cancelar
                                    </button>
                                </>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
